"use client";

import { c as _c } from "react/compiler-runtime";
import { NextIntlClientProvider, AbstractIntlMessages } from "next-intl";
export function ClientIntlProvider(t0) {
  const $ = _c(4);
  const {
    messages,
    locale,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== locale || $[2] !== messages) {
    t1 = <NextIntlClientProvider messages={messages} locale={locale} getMessageFallback={_temp} onError={_temp2}>{children}</NextIntlClientProvider>;
    $[0] = children;
    $[1] = locale;
    $[2] = messages;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(error) {
  if (error.code === "MISSING_MESSAGE") {
    return;
  }
  console.error(error);
}
function _temp(t0) {
  const {
    key
  } = t0;
  return key;
}